import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface WidgetButtonRootProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}

const RootComponent: React.FC<WidgetButtonRootProps> = ({
  children,
  className,
  onClick,
  disabled,
}) => {
  return (
    <button className={className} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export const Root: React.FC<WidgetButtonRootProps> = (
  props: WidgetButtonRootProps
) => {
  const Component = useCustomComponent({
    componentName: 'WidgetButtonRoot',
    Component: RootComponent,
  });

  return <Component {...props} />;
};
